import React, {PropsWithChildren} from 'react';
import {observer} from "mobx-react";
import {FlexContainerBox} from '../../../../themes/architecture/css-helpers/flex';

export const VideoSlideContentLayoutComponent: React.FC<PropsWithChildren> = observer((props) => {

    return (
        <FlexContainerBox direction='column' style={{height: "100%"}}>
            {props.children}
        </FlexContainerBox>
    )
})